import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { FormattedMessage } from 'react-intl';
import Button from '../../Button';
import { getTextColorsFromSection } from '../../lib/colors';
import Section from '../../Section';
import Typography from '../../Typography';

function PreOrderExpired({ classes, event, site, section, onRestart, theme }) {
  const { styles } = section;

  const colors = getTextColorsFromSection(site, section);

  return (
    <Section
      site={site}
      section={section}
      rootClassName={classes.sectionRoot}
      className={classes.root}
    >
      <Typography
        type="title"
        className={classes.title}
        paragraph
        style={{ ...colors.title, ...section.styles.title }}
      >
        <FormattedMessage id="preOrderExpiredTitle" />
      </Typography>
      <Typography
        className={classes.description}
        paragraph
        style={{ ...colors.text, ...styles.text }}
      >
        <FormattedMessage id="preOrderExpiredDescription" />
      </Typography>
      <Button
        event={event}
        site={site}
        section={section}
        style={{ ...styles.button, backgroundColor: theme.palette.success[500] }}
        className={classes.button}
        onClick={onRestart}
      >
        <FormattedMessage id="preOrderExpiredButton" />
      </Button>
    </Section>
  );
}

PreOrderExpired.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  onRestart: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  sectionRoot: {
    height: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.large,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.medium,
    },
  },
  title: {
    paddingRight: theme.spacing.large,
  },
  description: {
    marginTop: theme.spacing.large,
    flex: 1,
  },
  button: {
    display: 'block',
    alignSelf: 'flex-end',
    margin: 0,
  },
});

export default compose(injectSheet(stylesheet))(PreOrderExpired);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/PreOrderExpired/PreOrderExpired.js